import { Kateg } from '../_classes/list/kateg';

export let Kategs: Kateg[] = [
  {id: 1, name: 'Дети-инвалиды с ограниченными возможностями в передвижении вследствие заболевания опорно-двигательного аппарата', status: true},
  {id: 2, name: 'Дети с 3-х лет с ограниченными возможностями в передвижении вследствие заболевания опорно-двигательного аппарата', status: true},
  {id: 3, name: 'Инвалиды 1-й и 2-й групп с ограниченными возможностями в передвижении по заболеванию опорно-двигательного аппарата', status: true},
  {id: 4, name: 'Инвалиды по зрению 1-й, 2-й группы', status: true},
  {id: 5, name: 'Больные, страдающие гемипарезами', status: true},
  {id: 7, name: 'Участники и инвалиды Великой Отечественной войны', status: true},
  {id: 8, name: 'Участники боевых действий', status: true},
  {id: 11, name: 'Находящиеся на учете в отделениях социально-медицинского и социального обсл. на дому МБУ КЦСОН', status: true},
  {id: 12, name: 'Заключившие договор пожизненного содержания с иждивением с МКУ "Социальная гарантия"', status: true},
  {id: 13, name: 'Один. пожилые гр. и инвалиды, временно ограниченные в передв., нужд. в прохождении курса реабилитации по показаниям врача в учреждениях здрав.', status: true},
  {id: 14, name: 'Один. пожилые гр. и инвалиды, временно ограниченные в передв., нужд. в прохождении курса реабилитации по показаниям врача в учреждениях здрав., им неухаж. родств.', status: true},
  {id: 15, name: 'Одинокие и од. проживающие гр., ограниченные в передв., направленные в органы медико-социальной экспертизы', status: true},
  {id: 16, name: 'Общественные объединения инвалидов', status: true}
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/kategs.ts